import '../../../scss/hotfood/components/hotfood-fable.scss'

import {
  Body1,
  Button,
  ButtonGroup,
  Input,
  Modal,
  RadioGroup,
} from '@sainsburys-tech/fable'
import React, { useState } from 'react'

interface IProps {
  handleClose: () => void
  handleSave: (reasonId: number, reasonDescription: string) => Promise<void>
  isOpen: boolean
}

const CloseCounterModal = (props: IProps) => {
  const [reasonId, setReasonId] = useState<string>('')
  const [reasonDescription, setReasonDescription] = useState('')
  const [reasonError, setReasonError] = useState('')
  const [descriptionError, setDescriptionError] = useState('')

  const isValid = (): boolean => {
    let valid = true
    setReasonError('')
    setDescriptionError('')
    if (!reasonId) {
      setReasonError('Please select a reason before closing the counter')
      valid = false
    }

    if (reasonId === '99' && reasonDescription === '') {
      setDescriptionError("Please describe why you're closing the counter")
      valid = false
    }

    return valid
  }

  const onReasonChange = (value: string) => {
    setReasonId(value)
    setReasonError('')
    setDescriptionError('')
  }

  const onSave = async () => {
    if (isValid()) {
      await props.handleSave(Number(reasonId), reasonDescription)
    }
  }

  return (
    <Modal
      size='md'
      onClose={() => props.handleClose()}
      isOpen={props.isOpen}
      testid='info-modal'
      header={{ label: 'Set counter to closed' }}
      className='c-production-counter-close-modal'
      renderFooter={
        <ButtonGroup
          align='center'
          style={{ width: '100%', marginTop: '2rem' }}
        >
          <Button
            className='hotfood-full-width'
            onClick={() => onSave()}
            testid='close-counter-button'
            isFullWidth
            variant='primary'
          >
            Close counter
          </Button>
          <Button
            className='hotfood-full-width'
            onClick={() => props.handleClose()}
            variant={'secondary'}
            style={{ backgroundColor: 'transparent' }}
            testid='cancel-button'
            isFullWidth
          >
            Cancel
          </Button>
        </ButtonGroup>
      }
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Body1 style={{ marginBottom: '1rem' }}>
          You DO NOT need to close the counter at the end of every shift, this
          function should only be used in extraordinary situations. Please pick
          a reason for closing the counter from the options below:
        </Body1>
        <div className='c-closure-reason-radio'>
          <RadioGroup
            isFullWidth={true}
            label='Reason for closing the counter'
            name='reason'
            value={reasonId}
            onChange={onReasonChange}
            options={[
              { label: 'No colleague available', value: '1' },
              { label: 'Emergency in store', value: '2' },
              { label: 'Other', value: '99' },
            ]}
            status={
              reasonError ? { message: reasonError, type: 'error' } : undefined
            }
            testid='closure-reason-radio'
          />
          {reasonId === '99' && (
            <Input
              name='other-reason'
              label='Why did you close the counter?'
              value={reasonDescription}
              onChange={(value) => setReasonDescription(value)}
              placeholder='Describe your issue'
              status={
                descriptionError
                  ? { message: descriptionError, type: 'error' }
                  : undefined
              }
              testid='other-reason-input'
            />
          )}
        </div>
      </div>
    </Modal>
  )
}

export default CloseCounterModal
